import posthog from 'posthog-js'

const bootstrapDistinctId = document.cookie
  .split('; ')
  .find(c => c.startsWith('ph_bootstrap_distinct_id='))
  ?.split('=')[1]

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: '/ingest',
  ui_host: 'https://us.posthog.com',
  defaults: '2025-05-24',
  capture_exceptions: false, // We use DataDog for this
  debug: process.env.NODE_ENV === 'development',
  // If the bootstrap cookie is present, include it in the config so that posthog-js can pick it up and use it as the distinct ID for the session.
  // This allows us to have a consistent distinct ID for users even before the posthog-js library has fully initialized and set its own cookie.
  ...(bootstrapDistinctId && { bootstrap: { distinctID: bootstrapDistinctId } }),
})
